module.exports = __webpack_public_path__ + "static/img/pro-7.e8a9a0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/pro-7.png
// module id = a3vA
// module chunks = 1